/**
 * Auth API Service
 * Handles all authentication-related API calls
 */

import { post, get, patch } from './client';

export const authApi = {
  /**
   * Login with email and password
   */
  login: async (email, password, loginMode) => {
    return post('/api/auth/login/user', {
      email,
      password,
      loginMode,
    });
  },

  /**
   * Login with demo access code
   */
  loginWithAccessCode: async (accessCode) => {
    return post('/api/auth/login', {
      accessCode,
    });
  },

  /**
   * Google OAuth login
   */
  googleLogin: async (credential, loginMode) => {
    return post('/api/auth/google', {
      credential,
      loginMode,
    });
  },

  /**
   * Sign up new user
   */
  signup: async (email, password, confirmPassword, fullName, role) => {
    return post('/api/auth/signup', {
      email,
      password,
      confirmPassword,
      fullName,
      role,
    });
  },

  /**
   * Refresh access token
   */
  refreshToken: async (refreshToken) => {
    return post('/api/auth/refresh', {
      refreshToken,
    });
  },

  /**
   * Logout user
   */
  logout: async (refreshToken) => {
    return post('/api/auth/logout', {
      refreshToken,
    });
  },

  /**
   * Verify email with token
   */
  verifyEmail: async (token) => {
    return post('/api/auth/verify-email', {
      token,
    });
  },

  /**
   * Resend verification email
   */
  resendVerification: async (email) => {
    return post('/api/auth/resend-verification', {
      email,
    });
  },

  /**
   * Request password reset
   */
  forgotPassword: async (email) => {
    return post('/api/auth/forgot-password', {
      email,
    });
  },

  /**
   * Reset password with token
   */
  resetPassword: async (token, newPassword, confirmPassword) => {
    return post('/api/auth/reset-password', {
      token,
      newPassword,
      confirmPassword,
    });
  },

  /**
   * Get current user info
   */
  me: async () => {
    return get('/api/auth/me');
  },

  /**
   * Update doctor profile fields (full_name, clinic_name, license_number, job_title)
   */
  updateProfile: async (fields) => {
    return patch('/api/auth/profile', fields);
  },
};
